import { render, staticRenderFns } from "./InterviewFeedbackDialog.vue?vue&type=template&id=23893cdc&scoped=true&"
import script from "./InterviewFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./InterviewFeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "./InterviewFeedbackDialog.vue?vue&type=style&index=0&id=23893cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23893cdc",
  null
  
)

export default component.exports